import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';
import PartnerCreateModal from './PartnerCreateModal';

class ReportGlobalInvoiceDeliveryModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#globalInvoiceDeliveryModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            ReportsModel,
            ChangeClient,
            ActualDate,
            ChangeInitialDate,
            ChangeFinalDate,
            ChangeUser,
            ChangeType,
            ListUsers,
            ChangeViewEntries,
            ChangeBill,
            ChangeCashNotes,
            ChangeCreditNotes,
            ChangeRefounds,
            ChangeDirectDeliveries,
            GenerateReport,
            ListReports,
            ShowPDFViewerModal,
            ShowPDFViewer,
            OpenPartnerModal,
            partners,
            pageTotal,
            SelectPartner,
            cleanDataPartners,
            RefreshPartner,
            MailTools,
            sucursales,
            ChangeSucursal,
            printhide,
            ShowFormatToPrint,
        } = this.props;

        return (
            <div className="modal fade" id="globalInvoiceDeliveryModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportSalesModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Reporte Global de Facturas o Entregas</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">

                                <div className='row'>
                                    {/* <div className='col-4'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Cliente:</strong></span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Codigo"
                                                value={ReportsModel.CardCode}
                                                onChange={(event) => ChangeClient(event)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        OpenPartnerModal();
                                                    }
                                                }}
                                            />
                                            <button
                                                type="button"
                                                style={{
                                                    backgroundColor: 'transparent'
                                                }}
                                                className="input-group-text"
                                                onClick={OpenPartnerModal}>
                                                <i className="fa fa-search" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div> */}
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Sucursal:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Sucursal}
                                                onChange={event => ChangeSucursal(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!sucursales && sucursales.map(sucursal => {
                                                    return (
                                                        <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                    )
                                                })}
                                                {/* <option value={'ALL'}>TODAS LAS SUCURSALES</option> */}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    {/* <div className='col-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Usuario/Vendedor:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.User}
                                                onChange={event => ChangeUser(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!ListUsers && ListUsers.map(list => {
                                                    return (
                                                        <option value={list.USER_CODE}>{`${list.U_NAME}`}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div> */}
                                    {/* <div className='col-4'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Tipo:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Type}
                                                onChange={event => ChangeType(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                <option value="contado">Contado</option>
                                                <option value="credito">Crédito</option>
                                                <option value="ambos">Ambos</option>
                                            </select>
                                        </div>
                                    </div> */}
                                </div>
                                <div className='row'>
                                </div>
                                {/* <div className='row'>
                                    <div className='col-4'>
                                        <div class="form-check mt-3 ml-2">
                                            <input class="form-check-input" type="checkbox" checked={ReportsModel.checkViewEntries} id="checkViewEntries" onClick={(event) => ChangeViewEntries()} />
                                            <label class="form-check-label" for="checkViewEntries">
                                                Visualizar partidas
                                            </label>
                                        </div>
                                    </div>
                                </div> */}
                                <div className='row'>
                                    <div className='col-12 mt-3 font-weight-bold'> Tipos de operación: </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkBill"
                                                        checked={ReportsModel.checkBill}
                                                        onClick={ChangeBill} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkBill"> Facturas </label>
                                        </div>
                                    </div>
                                    {/* <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkCashNotes"
                                                        checked={ReportsModel.checkCashNotes}
                                                        onClick={ChangeCashNotes} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkCashNotes"> Notas de caja </label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkCreditNotes"
                                                        checked={ReportsModel.checkCreditNotes}
                                                        onClick={ChangeCreditNotes} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkCreditNotes"> Notas de crédito </label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkRefounds"
                                                        checked={ReportsModel.checkRefounds}
                                                        onClick={ChangeRefounds} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkRefounds"> Devoluciones </label>
                                        </div>
                                    </div> */}
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkDirectDeliveries"
                                                        checked={ReportsModel.checkDirectDeliveries}
                                                        onClick={ChangeDirectDeliveries} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkDirectDeliveries"> Entregas directas </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReport()}>Generar</button>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={'Report_GlobalInvoiceDelivey'}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={'SalesTools.EditableDocModel'}
                        RefreshDocModel={'SalesTools.RefreshDocModel'}
                        SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                        UploadDoc={'SalesTools.UploadInvoice'}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={'user'}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }

                {partners.length > 0 &&
                    <PartnerCreateModal
                        data={partners}
                        type={'C'}
                        totalPage={pageTotal}
                        selectPartner={SelectPartner}
                        cleanData={cleanDataPartners}
                        refreshPartner={RefreshPartner}
                    />
                }
            </div>
        );
    }
}

export default ReportGlobalInvoiceDeliveryModal;